import { createTypeReducer } from '@gu-corp/redux-async-lib';
import { IUser } from '~/../backend/types/user';
import * as UserStateActions from '../actions/user-state-actions';
import { EcosystemApp } from '~/utils/ecosystem.util';
import { AssetToken, Network } from '~/utils/joc-resource.util';

export type IState = {
  account?: IUser & {
    balance: bigint;
    testnetBalance: bigint;
    tokenId?: string;
    usdtxBalance: bigint;
    usdtxDecimals: number;
  };
  ecosystemApps?: EcosystemApp[];
  networks?: Network[];
  assetTokens?: Array<
    AssetToken & {
      lastSeenAt?: string;
    }
  >;
};

export const initialState: IState = {};
export const getAccountReducer = UserStateActions.getAccountAction.reducer<IState>(
  (state, action) => {
    if (action.error) {
      return {};
    }
    return {
      account: action.payload,
    };
  },
);

export const getEcosystemAppsReducer = UserStateActions.getEcosystemAppsAction.reducer<IState>(
  (state, action) => {
    if (action.error) {
      return {};
    }
    return {
      ecosystemApps: action.payload,
    };
  },
);

export const getAssetTokensReducer = UserStateActions.getAssetTokensAction.reducer<IState>(
  (state, action) => {
    if (action.error) {
      return {};
    }
    return {
      assetTokens: action.payload.updatedTokens,
      networks: action.payload.networks,
    };
  },
);

export const logoutAccountReducer = UserStateActions.logoutAction.reducer<IState>(
  (state, action) => {
    if (action.error) {
      return {};
    }
    return {
      account: undefined,
    };
  },
);

export const reducer = createTypeReducer(
  initialState,
  getAccountReducer,
  logoutAccountReducer,
  getEcosystemAppsReducer,
  getAssetTokensReducer,
  logoutAccountReducer,
);
